<template>
    <div class="min-h-screen min-w-screen bg-gray-900 font-londrina flex items-center overflow-hidden justify-center">
        <div class="flex flex-col sm:flex-row w-full inset-0 justify-center">
    <!-- Left Section (Image with Gradient) -->
    <div class="relative flex-[1] min-h-[50vh] sm:min-h-screen">
        <img src="./assets/logo-examples/holey-grail.png" class="w-full h-full object-cover">
        <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent via-gray-900/50 to-gray-900"></div>
    </div>
    <!-- Right Section (Form Content) -->
    <div class="flex justify-center text-white my-10 p-8 flex-[1]">
        <div v-if=toggleLogin class="flex flex-col gap-4 justify-center items-center text-center w-4/5 max-w-[380px]">
            <div class="text-2xl">
                Get Started
            </div>
            <div class="flex flex-row gap-4 w-full">
                <input id="first-name-input" class="bg-gray-700 p-2 rounded-md w-full" type="text" placeholder="First Name">
                <input id="last-name-input" class="bg-gray-700 p-2 rounded-md w-full" type="text" placeholder="Last Name">
            </div>
            <input id="email-input" class="bg-gray-700 p-2 rounded-md w-full" type="text" placeholder="Email">
            <!-- <div class="flex flex-row gap-2">
                <input class="bg-gray-700 rounded-md" type="checkbox">
                <span>I agree to the <a class="underline">Terms & Conditions</a></span>
            </div> -->
            <button @click="beginCheckout" class="transition ease-in-out w-3/4 max-w-[180px] min-h-3 text-white uppercase bg-[#0079E3] py-2 px-4 shadow-lg flex hover:scale-105 justify-center focus:bg-gray-400">
                <span v-if="loading">
                  <svg
                    class="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg> <!-- You can style this as you want -->
                </span>  
                <span v-else>Confirm</span>
            </button>
        </div>
        <div v-else class="flex flex-col gap-4 justify-center items-center text-center w-4/5 max-w-[380px]">
            <div class="text-2xl">
                Login
            </div>
            <div class="font-thin font-xs">
                Not got an account yet? <span @click="changeLogin" class="text-gray-400 underline">Signup here</span>
            </div>
            <input id="login-email" class="bg-gray-700 p-2 rounded-md w-full" type="text" placeholder="Email">
            <input id="login-password" class="bg-gray-700 p-2 rounded-md w-full" type="password" placeholder="Enter your password">
            <button class="transition ease-in-out text-white uppercase bg-[#0079E3] py-2 px-4 shadow-lg flex hover:scale-105 justify-center">
                Login
            </button>
        </div>
    </div>
</div>
    </div>
</template>

<script>

export default {
    name: "signup",
    methods: {
        changeLogin() {
            this.toggleLogin = !this.toggleLogin;
        },
        beginCheckout() {
            this.loading = true; //show loader
            // Collect user data
            const firstName = document.getElementById('first-name-input').value;
            const lastName = document.getElementById('last-name-input').value;
            const email = document.getElementById('email-input').value;

            if (!firstName || !lastName || !email ) {
                alert("Please complete all fields.");
                return;
            }

            // Create Stripe customer
            fetch("https://1dtb961u4e.execute-api.eu-west-2.amazonaws.com/dev/signup", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                }),
            })
            .then((res) => {
                if (res.ok) return res.json();
                return res.json().then((json) => Promise.reject(json));
            })
            .then((signupData) => {
                console.log("User signed up:", signupData);

                // Proceed to create checkout session
                return fetch("https://1dtb961u4e.execute-api.eu-west-2.amazonaws.com/dev/create-checkout-session", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: [{ id: 1, quantity: 1 }],
                        customerId: signupData.stripeCustomerId, // Pass the created customer's ID
                    }),
                });
            })
            .then((res) => {
                if (res.ok) return res.json();
                return res.json().then((json) => Promise.reject(json));
            })
            .then(({ url }) => {
                // Redirect to checkout page
                window.location = url;
            })
            .catch((e) => {
                console.error("Error:", e.error || e.message || e);
                alert("An error occurred: " + (e.error || e.message || "Unknown error"));
            });

        }

    },
    data() {
        return {
            toggleLogin: true,
            loading: false,
        }
    }
};

</script>